export const PRIJEMROBE_V1ResourcesEN: PRIJEMROBE_V1ResourcesBSInterface = {
  labelDone: "Task completion date",
  errorMissingInput: "Please fill in all fields",
  errors: {
    registerPic: "The picture you are uploading is too large.",
    recordAlreadyExists:
      "This evidence has already been filled out. You cannot fill it out again.",
  },
  input: {
    signatureTitle: "Signature",
    datum: {
      label: "Date",
      placeholder: "Please enter date",
      name: "datum",
    },
    ispravnaPosiljka: {
      label: "Is the shipment incorrect?",
      placeholder: "Please enter if the shipment is incorrect",
      name: "ispravnaPosiljka",
    },
    dokument: {
      label: "Documents",
      placeholder: "Please enter documents",
      name: "dokument",
      description: () => (
        <>
          <h4>Drop files here or click to upload.</h4>
          <span className="text-muted font-13">Only images, max 6MB</span>
        </>
      ),
    },
    korektivnaMjera: {
      label: "Corrective measure",
      placeholder: "Please enter corrective measure",
      name: "korektivnaMjera",
    },
    potpisPrimalac: {
      label: "Please sign the delivery",
      placeholder: "",
      name: "potpisano",
    },
    primalac: {
      label: "Deliverer",
      placeholder: "Please enter deliverer name / company name",
      name: "primalac",
    },
    primjedba: {
      label: "Remark",
      placeholder: "Please enter remark",
      name: "primjedba",
    },
    temperatura: {
      label: "Temperature",
      placeholder: "Please enter temperature",
      name: "temperatura",
    },
  },
  evidencijaForm: {
    buttonForward: "Sign",
    buttonBack: "Back",
  },
  successModal: {
    title: "Data Entry",
    body: "Data addition has been successfully completed. Select OK to continue.",
    buttonOk: "OK",
  },
  txtPotvrda:
    "By selecting the Sign option, I confirm that the task has been performed according to the instructions!",
};

interface InputField {
  label: string;
  placeholder: string;
  name: string;
  description?: () => JSX.Element;
}

interface Input {
  signatureTitle: string;
  datum: InputField;
  ispravnaPosiljka: InputField;
  dokument: InputField;
  korektivnaMjera: InputField;
  potpisPrimalac: InputField;
  primalac: InputField;
  primjedba: InputField;
  temperatura: InputField;
}

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

interface IErrors {
  registerPic: string;
  recordAlreadyExists: string;
}

export interface PRIJEMROBE_V1ResourcesBSInterface {
  labelDone: string;
  errorMissingInput: string;
  input: Input;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
  errors: IErrors;
}
